(function () {
  'use strict';

  function planId(line) {
    return String(line.selling_plan_allocation && line.selling_plan_allocation.selling_plan.id || line.selling_plan || '');
  }
  function identity(line) {
    return JSON.stringify([String(line.variant_id || line.id), planId(line), Object.entries(line.properties || {}).sort(function (a, b) { return a[0].localeCompare(b[0]); })]);
  }
  function resolveLine(cart, key, original) {
    var exact = cart.items.find(function (line) { return line.key === key; });
    if (exact) return exact;
    var matches = original ? cart.items.filter(function (line) { return identity(line) === original; }) : [];
    // Discounts can change a key. Never guess between split lines with the same identity.
    return matches.length === 1 ? matches[0] : null;
  }
  function strictDeadline(value) {
    var match = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(?:\.\d+)?)?(Z|[+-]\d\d:\d\d)$/.exec(value || '');
    if (!match) return NaN;
    var year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
    if (month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate() || Number(match[4]) > 23 || Number(match[5]) > 59 || Number(match[6] || 0) > 59) return NaN;
    return Date.parse(value);
  }
  function validCart(value) {
    return value && Array.isArray(value.items) && Number.isSafeInteger(value.total_price) && value.total_price >= 0 && typeof value.currency === 'string';
  }
  var handles = new Set(['elk-mesquite-meat-sticks', 'jalapeno-cheese-meat-stick', 'teriyaki-meat-stick', 'hickory-venison-meat-sticks', 'peppered-beef-jerky', 'jalapeno-honey-meat-sticks', 'original-meat-stick', 'habanero-heat-jerky', 'sweet-heat-jerky', 'honey-bbq-jerky', 'teriyaki-pork-jerky', 'hickory-bbq-jerky', 'original-beef-jerky', 'beefcake-jalapeno-cheese-beef-bites']);
  var standardPlans = new Set(['9632678195', '9629368627']);
  function packCount(variant) {
    var match = String(variant && (variant.option1 || variant.title) || '').match(/^(\d+)\s*(?:pack|bag|stick)?\b/i);
    return match ? Number(match[1]) : 0;
  }
  function comparison(line, product, promotion) {
    if (!handles.has(line.handle) || line.has_components || line.parent_relationship || (line.properties && line.properties._dynamicBoxId) || (planId(line) && !standardPlans.has(planId(line)))) return null;
    var variant = product.variants.find(function (v) { return String(v.id) === String(line.variant_id); });
    if (!variant || !packCount(variant) || !Number.isSafeInteger(line.quantity) || line.quantity < 1 || !Number.isSafeInteger(line.final_line_price) || line.final_line_price < 0 || !Number.isSafeInteger(variant.price)) return null;
    if (planId(line) && !(variant.selling_plan_allocations || []).some(function (a) { return String(a.selling_plan_id) === planId(line); })) return null;
    var baseline = product.variants.filter(function (v) { return v.available && packCount(v) && Number.isSafeInteger(v.price) && v.price > 0; }).sort(function (a, b) { return packCount(a) - packCount(b); })[0];
    var reference = variant.price, caption = 'vs_onetime', count = 0;
    if (!(!planId(line) && promotion && promotion.active && promotion.price < variant.price) && baseline && packCount(variant) > packCount(baseline)) {
      count = packCount(baseline);
      reference = Math.round(baseline.price * packCount(variant) / count);
      caption = count === 1 ? 'vs_singles' : 'vs_packs';
    }
    reference *= line.quantity;
    return Number.isSafeInteger(reference) ? { reference: reference, saved: Math.max(0, reference - line.final_line_price), caption: caption, count: count } : null;
  }
  if (typeof module === 'object' && module.exports) module.exports = { identity: identity, resolveLine: resolveLine, strictDeadline: strictDeadline, validCart: validCart, comparison: comparison };
  if (typeof document === 'undefined') return;
  var drawer = document.getElementById('BCJCartDrawer');
  if (!drawer || window.BCJCart) return;

  var cart, pending = 0, blocked = true, queue = Promise.resolve(), opener, scrollY = 0;
  var generation = 0, undo, undoTimer, campaignTimer, refreshTimer, checkoutStarted = false, pendingFocus;
  var expired = new Set(), products = new Map(), inputRequests = new WeakMap(), controlLocks = new WeakMap();
  var strings = JSON.parse(drawer.querySelector('[data-bcj-cart-strings]').textContent);
  function t(key) {
    var aliases = { failed: 'update_error', unverified: 'uncertain_error', code_applied: 'discount_applied', code_invalid: 'discount_invalid', code_removed: 'discount_removed', campaign_countdown: 'offer_ends_in', saved: 'savings_prefix', vs_onetime: 'savings_onetime', vs_singles: 'savings_single', vs_packs: 'savings_pack' };
    return strings[key] || strings[aliases[key]] || strings.update_error;
  }
  function route(path) { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/?$/, '/') + path; }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }
  function track(action, detail) {
    var data = Object.assign({ action: action, surface: 'native_cart_drawer', version: '2026-10-12' }, detail || {});
    emit('bcj:cart:analytics', data);
    // Custom pixel listeners can join these with Shopify checkout_completed. Never send cart tokens or customer data.
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { Promise.resolve(window.Shopify.analytics.publish('bcj_cart_' + action, data)).catch(function () {}); } catch (_) { /* Analytics must not interrupt cart operations. */ }
    }
  }
  function status(message) { drawer.querySelector('[data-bcj-status]').textContent = message || ''; }
  function errorNotice(message) {
    var node = drawer.querySelector('[data-bcj-error]');
    node.textContent = message || ''; node.hidden = !message;
  }
  function busy() {
    drawer.setAttribute('aria-busy', pending ? 'true' : 'false');
    drawer.querySelectorAll('[data-bcj-checkout]').forEach(function (button) { button.disabled = !!(pending || blocked || checkoutStarted); });
    drawer.querySelectorAll('[data-bcj-qty], [data-bcj-quantity], [data-bcj-remove], [data-bcj-code-input], [data-bcj-code-apply], [data-bcj-code-remove], [data-bcj-note], [data-bcj-recommendation-add], [data-bcj-recommendation-variant], [data-bcj-undo]').forEach(function (control) {
      if (pending || checkoutStarted) {
        if (!controlLocks.has(control)) controlLocks.set(control, control.disabled);
        control.disabled = true;
      } else if (controlLocks.has(control)) {
        control.disabled = controlLocks.get(control); controlLocks.delete(control);
      }
    });
    // Include the full-cart fallback in the same checkout lock.
    document.querySelectorAll('#CartPageForm [name="checkout"]').forEach(function (button) { button.disabled = !!(pending || blocked || checkoutStarted); });
    emit('bcj:cart:state', { pending: pending, blocked: blocked || checkoutStarted });
  }
  function failure(reason, stage, message) {
    var error = new Error(message || t('unverified'));
    error.error_reason = reason; error.error_stage = stage;
    return error;
  }
  async function request(path, payload, html) {
    var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 15000);
    var stage = payload ? 'write' : path === 'cart.js' ? 'cart_read' : path === 'cart?view=drawer' ? 'drawer_read' : 'unknown';
    try {
      var response;
      try {
        response = await fetch(route(path), { method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: { Accept: html ? 'text/html' : 'application/json', 'Content-Type': 'application/json' }, body: payload ? JSON.stringify(payload) : undefined });
      } catch (error) { throw failure(controller.signal.aborted ? 'timeout' : 'network', stage, t('failed')); }
      var result;
      try { result = html ? await response.text() : await response.json(); }
      catch (error) {
        if (response.ok) throw failure(controller.signal.aborted ? 'timeout' : error.name === 'SyntaxError' ? 'parse' : 'network', stage, t('failed'));
      }
      if (!response.ok) {
        var error = failure(response.status >= 500 ? 'http_server' : response.status >= 400 ? 'http_client' : 'http_other', stage,
          result && typeof result.description === 'string' ? result.description : t('failed'));
        error.definite = response.status >= 400 && response.status < 500;
        error.http_status = response.status;
        throw error;
      }
      return result;
    } finally { clearTimeout(timeout); }
  }
  function rememberFocus() {
    var element = document.activeElement;
    if (!drawer.contains(element)) return null;
    var row = element.closest('[data-key]'), line = row && cart && cart.items.find(function (item) { return item.key === row.dataset.key; });
    var attribute = ['data-bcj-quantity', 'data-bcj-qty', 'data-bcj-remove', 'data-bcj-close', 'data-bcj-code-input', 'data-bcj-code-apply', 'data-bcj-checkout', 'data-bcj-note'].find(function (key) { return element.hasAttribute(key); });
    return { attribute: attribute, value: attribute && element.getAttribute(attribute), key: row && row.dataset.key, identity: line && identity(line), id: element.id };
  }
  function restoreFocus(saved) {
    if (!saved || !drawer.open) return;
    var scope = drawer;
    if (saved.key) {
      var line = resolveLine(cart, saved.key, saved.identity);
      scope = line && Array.from(drawer.querySelectorAll('[data-key]')).find(function (row) { return row.dataset.key === line.key; });
    }
    var target = scope && (saved.attribute ? Array.from(scope.querySelectorAll('[' + saved.attribute + ']')).find(function (node) { return node.getAttribute(saved.attribute) === saved.value; }) : saved.id && document.getElementById(saved.id));
    (target || drawer.querySelector('[data-bcj-close]')).focus({ preventScroll: true });
  }
  function loadArt() {
    if (!drawer.open) return;
    drawer.querySelectorAll('img[data-src]').forEach(function (img) {
      img.addEventListener('error', function () {
        var banner = img.closest('.bcj-drawer__banner');
        if (!banner) return;
        if (banner.querySelector('.bcj-drawer__banner-proof')) {
          img.hidden = true;
          banner.classList.add('bcj-drawer__banner--image-failed');
        } else {
          banner.hidden = true;
        }
      }, { once: true });
      img.srcset = img.dataset.srcset || ''; img.src = img.dataset.src;
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
    });
  }
  function paintCodes() {
    var list = drawer.querySelector('[data-bcj-code-list]');
    if (!list || !Array.isArray(cart.discount_codes)) return;
    list.replaceChildren();
    cart.discount_codes.filter(function (code) { return code.applicable; }).forEach(function (code) {
      var button = document.createElement('button'); button.type = 'button'; button.className = 'bcj-drawer__code-chip';
      button.dataset.bcjCodeRemove = code.code; button.textContent = code.code + ' ×';
      button.setAttribute('aria-label', (strings.remove_code || '__code__ ×').replace('__code__', code.code)); list.append(button);
    });
  }
  async function reconcile() {
    var saved = rememberFocus(), content = drawer.querySelector('[data-bcj-cart-content]');
    var oldScroll = drawer.querySelector('[data-bcj-cart-scroll]'), top = oldScroll ? oldScroll.scrollTop : 0;
    var codeOpen = drawer.querySelector('[data-bcj-code-details]'), codeValue = drawer.querySelector('[data-bcj-code-input]');
    var terms = drawer.querySelector('[data-bcj-terms]'), agreed = terms && terms.checked;
    var next = await request('cart.js');
    if (!validCart(next)) throw failure('cart_invalid', 'cart_validate');
    var html = await request('cart?view=drawer', null, true);
    var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bcj-cart-content]');
    if (!parsed) throw failure('render_missing', 'drawer_validate');
    if (Number(parsed.dataset.count) !== next.item_count || Number(parsed.dataset.cartSubtotal) !== next.total_price) throw failure('render_mismatch', 'drawer_validate');
    var rendered = Array.from(parsed.querySelectorAll('[data-bcj-cart-item][data-key]'));
    if (rendered.length !== next.items.length || next.items.some(function (line) {
      var row = rendered.find(function (node) { return node.dataset.key === line.key; });
      var quantity = row && row.querySelector('[data-bcj-quantity]');
      return !quantity || Number(quantity.value) !== line.quantity;
    })) throw failure('render_mismatch', 'drawer_validate');
    content.replaceWith(parsed); cart = next; blocked = false; generation += 1;
    if (codeOpen && codeOpen.open && drawer.querySelector('[data-bcj-code-details]')) drawer.querySelector('[data-bcj-code-details]').open = true;
    if (codeValue && drawer.querySelector('[data-bcj-code-input]')) drawer.querySelector('[data-bcj-code-input]').value = codeValue.value;
    if (agreed && drawer.querySelector('[data-bcj-terms]')) drawer.querySelector('[data-bcj-terms]').checked = true;
    drawer.querySelector('[data-bcj-cart-scroll]').scrollTop = top;
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (node) { node.textContent = cart.item_count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (node) { node.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
    paintCodes(); busy(); restoreFocus(saved); loadArt(); paintEnhancements(generation);
    emit('cart:updated', { cart: cart, bcjCartHandled: true });
    return cart;
  }
  function enqueue(work, operation) {
    if (!pending) pendingFocus = rememberFocus();
    pending += 1; busy(); status(t('updating')); errorNotice('');
    var run = queue.catch(function () {}).then(work).catch(function (error) {
      errorNotice(blocked ? t('unverified') : error.message || t('failed'));
      status('');
      var detail = { operation: operation || 'refresh', error_stage: error.error_stage || 'unknown', error_reason: error.error_reason || 'unknown', uncertain: !!error.uncertain, blocked: blocked };
      if (Number.isInteger(error.http_status) && error.http_status >= 100 && error.http_status <= 599) detail.http_status = error.http_status;
      track('error', detail);
      throw error;
    }).finally(function () {
      pending -= 1; busy();
      if (!pending) {
        if (drawer.querySelector('[data-bcj-status]').textContent === t('updating')) status(t('updated'));
        if (!document.activeElement || document.activeElement === document.body || document.activeElement === drawer || !document.activeElement.isConnected) restoreFocus(pendingFocus);
        pendingFocus = null;
      }
    });
    queue = run.catch(function () {}); return run;
  }
  async function mutation(path, payload) {
    try {
      var result = await request(path, payload);
      await reconcile();
      if (document.getElementById('CartPageForm')) emit('cart:build', { bcjCartHandled: true });
      return result;
    } catch (error) {
      // A timeout can occur after Shopify has committed the request. Read; never replay.
      error.uncertain = !error.definite;
      try { await reconcile(); } catch (_) { blocked = true; }
      throw error;
    }
  }
  function show() {
    if (drawer.open) return;
    if (typeof drawer.showModal !== 'function') { window.location.assign(route('cart')); return; }
    opener = document.activeElement; scrollY = window.scrollY;
    document.documentElement.classList.add('bcj-cart-open');
    document.body.style.setProperty('--bcj-cart-scroll-y', '-' + scrollY + 'px');
    drawer.showModal(); loadArt(); track('opened', { item_count: cart ? cart.item_count : null });
    document.querySelectorAll('.js-drawer-open-cart, [data-bcj-open-cart]').forEach(function (node) { node.setAttribute('aria-expanded', 'true'); });
  }
  function close() {
    if (!drawer.open) return;
    drawer.close();
  }
  drawer.addEventListener('close', function () {
    document.documentElement.classList.remove('bcj-cart-open'); document.body.style.removeProperty('--bcj-cart-scroll-y');
    document.querySelectorAll('.js-drawer-open-cart, [data-bcj-open-cart]').forEach(function (node) { node.setAttribute('aria-expanded', 'false'); });
    window.scrollTo(0, scrollY); if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
  function refresh(options) {
    if (options && options.open) show();
    return enqueue(async function () { try { return await reconcile(); } catch (error) { blocked = true; throw error; } }, options && options.operation === 'initial' ? 'initial' : 'refresh');
  }
  function add(items, options) {
    options = options || {};
    if (checkoutStarted) return Promise.reject(new Error(t('checkout_wait')));
    return enqueue(async function () {
      if (blocked) await reconcile();
      var result = await mutation('cart/add.js', { items: items });
      if (options.open !== false) show();
      emit('ajaxProduct:added', { product: result, bcjCartHandled: true });
      status(t('added')); track('added', { source: options.source || 'product', item_count: cart.item_count });
      return cart;
    }, 'add');
  }
  function change(key, quantity, delta) {
    if (checkoutStarted) return Promise.reject(new Error(t('checkout_wait')));
    var original = cart && cart.items.find(function (line) { return line.key === key; }), originalIdentity = original && identity(original);
    return enqueue(async function () {
      if (blocked || !cart) await reconcile();
      var line = resolveLine(cart, key, originalIdentity);
      if (!line) throw failure('line_missing', 'input', t('failed'));
      var nextQuantity = delta ? line.quantity + delta : quantity;
      if (!Number.isSafeInteger(nextQuantity) || nextQuantity < 0) throw failure('input_invalid', 'input', t('failed'));
      if (nextQuantity === line.quantity) return cart;
      await mutation('cart/change.js', { id: line.key, quantity: nextQuantity });
      if (nextQuantity === 0) offerUndo(line);
      track(nextQuantity ? 'quantity_changed' : 'removed', { variant_id: line.variant_id, quantity: nextQuantity });
      return cart;
    }, 'change');
  }
  function offerUndo(line) {
    clearTimeout(undoTimer); undo = { id: line.variant_id, quantity: line.quantity, properties: line.properties || {} };
    if (planId(line)) undo.selling_plan = planId(line);
    // Shopify component relationships cannot safely be reconstructed as ordinary adds.
    if (line.has_components || line.parent_relationship) { undo = null; return; }
    drawer.querySelector('[data-bcj-undo-region]').hidden = false; status(t('removed'));
    undoTimer = setTimeout(function () { undo = null; drawer.querySelector('[data-bcj-undo-region]').hidden = true; }, 12000);
  }
  function codes() { return (cart.discount_codes || []).map(function (code) { return code.code; }); }
  function codeMessage(message, invalid) {
    var details = drawer.querySelector('[data-bcj-code-details]');
    if (!details) return;
    details.open = true; drawer.querySelector('[data-bcj-code-message]').textContent = message;
    drawer.querySelector('[data-bcj-code-input]').setAttribute('aria-invalid', invalid ? 'true' : 'false');
  }
  function discount(code, remove) {
    if (checkoutStarted) return Promise.reject(new Error(t('checkout_wait')));
    return enqueue(async function () {
      if (!cart || blocked) await reconcile();
      var current = codes(), list = current.filter(function (value) { return value.toLowerCase() !== code.toLowerCase(); });
      if (!remove) list.push(code);
      await mutation('cart/update.js', { discount: list.join(',') });
      var applied = (cart.discount_codes || []).some(function (value) { return value.code.toLowerCase() === code.toLowerCase() && value.applicable; });
      codeMessage(t(remove ? 'code_removed' : applied ? 'code_applied' : 'code_invalid'), !remove && !applied);
      track('discount', { applicable: applied, removed: !!remove });
      return cart;
    }, 'discount');
  }
  function productFor(handle) {
    var key = route('') + ':' + cart.currency + ':' + (window.Shopify && window.Shopify.country || '') + ':' + handle;
    var cached = products.get(key);
    if (!cached || Date.now() - cached.time > 30000) {
      cached = { time: Date.now(), promise: request('products/' + encodeURIComponent(handle) + '.js') }; products.set(key, cached);
      cached.promise.catch(function () { products.delete(key); });
    }
    return cached.promise;
  }
  function money(amount) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency }).format(amount / 100); }
  function promotion(line, price, expectedId) {
    return window.BCJPromotion && window.BCJPromotion.details({ handle: line.handle, variantId: line.variant_id, price: price, sellingPlanId: planId(line) }, expectedId);
  }
  function paintEnhancements(revision) {
    paintCampaign();
    cart.items.filter(function (line) { return handles.has(line.handle); }).forEach(function (line) {
      productFor(line.handle).then(function (product) {
        if (revision !== generation) return;
        var variant = product.variants.find(function (value) { return value.id === line.variant_id; });
        var model = comparison(line, product, variant && promotion(line, variant.price));
        var row = Array.from(drawer.querySelectorAll('[data-key]')).find(function (node) { return node.dataset.key === line.key; });
        if (!row || !model || !model.saved) return;
        var box = row.querySelector('[data-bcj-pack-savings]'); box.hidden = false;
        box.querySelector('[data-bcj-pack-savings-value]').textContent = t('saved').replace('__amount__', money(model.saved));
        box.querySelector('[data-bcj-pack-savings-caption]').textContent = t(model.caption).replace('__count__', model.count) + ' (' + money(model.reference) + ').';
      }).catch(function () { /* Optional comparison must never block purchasing. */ });
    });
    drawer.querySelectorAll('[data-bcj-recommendation]').forEach(function (row) {
      row.querySelectorAll('option[data-price]').forEach(function (option) {
        var price = Number(option.dataset.price), detail = promotion({ handle: row.dataset.productHandle, variant_id: option.value }, price);
        if (detail && detail.active) option.textContent = option.textContent.split(' · ')[0] + ' · ' + money(detail.price);
      });
    });
  }
  function paintCampaign() {
    clearTimeout(campaignTimer);
    var node = drawer.querySelector('[data-bcj-campaign]');
    if (!node || !cart) return;
    node.hidden = true;
    var deadline = strictDeadline(node.dataset.endAt), abra = window.Abra, offer = abra && abra.publicPromotion;
    var current;
    try { current = abra && abra.currentPromotionDetails && abra.currentPromotionDetails(); } catch (_) { return; }
    if (!offer || !current || offer.id !== node.dataset.campaignId || current.id !== offer.id || strictDeadline(offer.endsAt) !== deadline || !Number.isFinite(deadline)) return;
    if (Date.now() >= deadline) {
      if (!expired.has(offer.id + deadline)) { expired.add(offer.id + deadline); refresh().catch(function () {}); }
      return;
    }
    if (!cart.items.some(function (line) { var detail = promotion(line, line.original_price, node.dataset.campaignId); return detail && detail.active && strictDeadline(detail.endsAt) === deadline; })) return;
    var seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    var time = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(function (value) { return String(value).padStart(2, '0'); }).join(':');
    node.textContent = node.dataset.mode === 'static' ? t('campaign_static').replace('__date__', new Date(deadline).toLocaleString(document.documentElement.lang || 'en', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })) : t('campaign_countdown').replace('__time__', time);
    node.hidden = false;
    campaignTimer = setTimeout(paintCampaign, Math.min(1000, deadline - Date.now() + 20));
  }
  function ignore(promise) { promise.catch(function () {}); }
  drawer.addEventListener('click', function (event) {
    var target = event.target.closest('button, [data-bcj-close]');
    if (event.target === drawer) { var bounds = drawer.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close(); }
    if (!target) return;
    if (target.hasAttribute('data-bcj-close')) close();
    if (target.disabled || pending || checkoutStarted) return;
    var row = target.closest('[data-key]');
    if (target.hasAttribute('data-bcj-qty')) ignore(change(row.dataset.key, null, Number(target.dataset.bcjQty)));
    if (target.hasAttribute('data-bcj-remove')) ignore(change(row.dataset.key, 0));
    if (target.hasAttribute('data-bcj-undo') && undo) {
      var item = undo; undo = null; clearTimeout(undoTimer); drawer.querySelector('[data-bcj-undo-region]').hidden = true;
      ignore(add([item], { open: true, source: 'undo' }).then(function () { status(t('restored')); }));
    }
    if (target.hasAttribute('data-bcj-recommendation-add')) {
      if (target.disabled) return; target.disabled = true;
      var recommendation = target.closest('[data-bcj-recommendation]');
      ignore(add([{ id: Number(recommendation.querySelector('select').value), quantity: 1 }], { open: true, source: 'recommendation' }).finally(function () { target.disabled = false; }));
    }
    if (target.hasAttribute('data-bcj-code-apply')) {
      var code = drawer.querySelector('[data-bcj-code-input]').value.trim();
      if (!code) codeMessage(t('code_required'), true); else ignore(discount(code, false));
    }
    if (target.hasAttribute('data-bcj-code-remove')) ignore(discount(target.dataset.bcjCodeRemove, true));
  });
  function editQuantity(input) {
    if (input.disabled || pending || checkoutStarted) return;
    var value = input.value.trim();
    if (!/^\d+$/.test(value)) { ignore(refresh().then(function () { errorNotice(t('failed')); })); return; }
    if (inputRequests.get(input) === value) return;
    inputRequests.set(input, value); ignore(change(input.closest('[data-key]').dataset.key, Number(value)));
  }
  drawer.addEventListener('change', function (event) {
    if (event.target.disabled || pending || checkoutStarted) return;
    if (event.target.matches('[data-bcj-quantity]')) editQuantity(event.target);
    if (event.target.matches('[data-bcj-note]')) { var note = event.target.value; ignore(enqueue(function () { return mutation('cart/update.js', { note: note }); }, 'note')); }
  });
  drawer.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      var focusable = Array.from(drawer.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), summary, [tabindex="0"]')).filter(function (node) { return node.getClientRects().length && node.tabIndex >= 0; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (first && ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last))) {
        event.preventDefault(); (event.shiftKey ? last : first).focus();
      }
    }
    if (event.key !== 'Enter') return;
    if (event.target.matches('[data-bcj-quantity]')) { event.preventDefault(); editQuantity(event.target); }
    if (event.target.matches('[data-bcj-code-input]')) { event.preventDefault(); drawer.querySelector('[data-bcj-code-apply]').click(); }
  });
  drawer.addEventListener('submit', function (event) {
    if (!event.target.matches('[data-bcj-checkout-form]')) return;
    event.preventDefault(); if (checkoutStarted) return; checkoutStarted = true; busy();
    ignore(enqueue(async function () {
      await reconcile();
      var form = drawer.querySelector('[data-bcj-checkout-form]');
      if (!form || !cart.item_count || !form.reportValidity()) throw failure('checkout_invalid', 'checkout', t('terms_required'));
      var field = document.createElement('input'); field.type = 'hidden'; field.name = 'checkout'; field.value = 'Checkout'; form.append(field);
      track('checkout_started', { item_count: cart.item_count, subtotal: cart.total_price, currency: cart.currency });
      HTMLFormElement.prototype.submit.call(form);
    }, 'checkout').catch(function (error) { checkoutStarted = false; busy(); throw error; }));
  });
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    var trigger = event.target.closest('.js-drawer-open-cart, [data-bcj-open-cart]');
    if (!trigger) return;
    event.preventDefault(); event.stopImmediatePropagation(); show(); ignore(refresh());
  }, true);
  document.addEventListener('ajaxProduct:added', function (event) { if (!event.detail || !event.detail.bcjCartHandled) { show(); ignore(refresh()); } });
  document.addEventListener('cart:open', function () { show(); ignore(refresh()); });
  document.addEventListener('cart:close', close);
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.bcjCartHandled) return;
    clearTimeout(refreshTimer); refreshTimer = setTimeout(function () { ignore(refresh()); }, 50);
  });
  window.addEventListener('bcj:promotion:change', function () { clearTimeout(refreshTimer); refreshTimer = setTimeout(function () { ignore(refresh()); }, 60); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { checkoutStarted = false; ignore(refresh()); } });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && drawer.open) ignore(refresh()); });
  function update(payload) {
    if (checkoutStarted) return Promise.reject(new Error(t('checkout_wait')));
    return enqueue(async function () { if (blocked) await reconcile(); await mutation('cart/update.js', payload); return cart; }, 'update');
  }
  window.BCJCart = { add: add, change: change, update: update, refresh: refresh, open: function () { show(); return refresh(); }, close: close, getCart: function () { return cart; }, getState: function () { return { pending: pending, blocked: blocked || checkoutStarted, checkoutStarted: checkoutStarted }; } };
  document.querySelectorAll('.js-drawer-open-cart, [data-bcj-open-cart]').forEach(function (node) {
    node.setAttribute('aria-controls', 'BCJCartDrawer'); node.setAttribute('aria-haspopup', 'dialog'); node.setAttribute('aria-expanded', 'false');
  });
  ignore(refresh({ operation: 'initial' }));
})();
